import { createFileRoute } from '@tanstack/react-router'
import { seo } from '~/client/common/seo'
import { SpaceRouteComponent } from './-app.spaces.$spaceId.component'
import { fetchSpaceData } from '~/server/space/space.service'

export const Route = createFileRoute('/_app/spaces/$mainVenueSlug/$spaceSlug')({
  loader: ({ params }) =>
    fetchSpaceData({
      data: { spaceSlug: params.spaceSlug, mainVenueSlug: params.mainVenueSlug },
    }),
  head: ({ loaderData }) => {
    const space = loaderData?.space
    const title = space
      ? `${space.name} - ${space.venue.name} - Revel Street`
      : 'Space - Revel Street'
    const description = space?.description || 'View space details and information'
    const image = space?.primaryImage?.url

    return { meta: seo({ title, description, image }) }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { space, otherSpaces } = Route.useLoaderData()
  return <SpaceRouteComponent space={space} otherSpaces={otherSpaces} />
}
